import React from 'react';
import Chart from 'react-google-charts';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import {
  NUMERIC_VALUE, _TYPE_NAME, GRAPH_CONST_VALUES, GRAPH_COLOR_CODE,
} from '../../../../utils';

function AudienceAgeChart(props) {
  const { audienceGraphData } = props;
  const ageDataArr = [];
  const ageUpdatedArr = [];

  ageDataArr.splice(0, 0, ['', '', { role: 'style' }, {
    sourceColumn: 0,
    role: 'annotation',
    type: 'string',
    calc: 'stringify',
  }]);

  const maxKey = Math.max.apply(null, Object.keys(omit(audienceGraphData, [_TYPE_NAME])).map((x) => audienceGraphData[x]));

  Object.entries(audienceGraphData).forEach(([key, value]) => {
    if (key !== _TYPE_NAME) {
      let splitValue = key.split('age_')[1];
      splitValue = splitValue.replace(/_/g, '-');
      if (splitValue === GRAPH_CONST_VALUES.SIXTY_FIVE_MINUS_PLUS) {
        splitValue = GRAPH_CONST_VALUES.SIXTY_FIVE_PLUS;
      }
      const colorCode = maxKey === value && maxKey !== NUMERIC_VALUE.ZERO ? GRAPH_COLOR_CODE.GREEN : GRAPH_COLOR_CODE.LIGHT_GREEN;
      ageUpdatedArr.push({ key: splitValue, value, color: colorCode });
    }
  });

  ageUpdatedArr.forEach((item) => {
    ageDataArr.push([item.key, item.value, `color: ${item.color}`, `${item.value}%`]);
  });

  const options = {
    legend: {
      position: 'none',
    },
    bar: { groupWidth: '50%', left: 0 },
    chartArea: { left: 0, width: '100%' },
    Axis: { textPosition: 'none', viewWindowMode: 'maximized' },
    vAxis: {
      gridlines: {
        color: 'transparent',
      },
      textPosition: 'none',
      minValue: 0,
      maxValue: 100,
    },
    hAxis: {
      gridlines: {
        color: 'transparent',
      },
      minValue: 0,
      maxValue: 100,
      barThickness: 20,
    },
  };
  return (
    <div className="App">
      <Chart chartType="ColumnChart" width="100%" height="280px" data={ageDataArr} options={options} className="audienceAgeChart" />
    </div>
  );
}

AudienceAgeChart.propTypes = {
  audienceGraphData: PropTypes.object.isRequired,
};

export default AudienceAgeChart;
